const interval = setInterval(function() {
  var inputField = $(".shopify-app-block .rc-field input");
  if (inputField.length) {
    const selector = ".shopify-app-block .rc-field"
    $(`${selector} input[id='first-name']`).attr("placeholder", "Your name");
    $(`${selector} input[id='email']`).attr("placeholder", "Your email address");
    clearInterval(interval);
  }
}, 100);



$(window).on('scroll resize', function () {
  if ($(window).width() <= 991) {
    var $container = $('.custom-add-to-cart-container');
    var $wrapper = $('.add-essentials-wrapper');

    if (!$wrapper.length || !$container.length) return; // safety check

    var scrollTop = $(window).scrollTop();
    var wrapperTop = $wrapper.offset().top;
    var wrapperHeight = $wrapper.outerHeight();
    var containerHeight = $container.outerHeight();
    var viewportHeight = $(window).height();

    // Added container height + 25px to the threshold
    if (scrollTop > wrapperTop + wrapperHeight + containerHeight + 25 - viewportHeight) {
      $container.addClass('sticky');
    } else {
      $container.removeClass('sticky');
    }
  }
}).trigger('scroll');


$(window).on('scroll resize', function () {
  if ($(window).width() <= 991) {
    var $container2 = $('.custom-add-to-cart-container');
    var $wrapper2 = $('.add-bundle-wrapper');

    if (!$wrapper2.length || !$container2.length) return; // safety check

    var scrollTop = $(window).scrollTop();
    var wrapperTop = $wrapper2.offset().top;
    var wrapperHeight = $wrapper2.outerHeight();
    var containerHeight = $container2.outerHeight();
    var viewportHeight = $(window).height();

    // Added container height + 25px to the threshold
    if (scrollTop > wrapperTop + wrapperHeight + containerHeight + 10 - viewportHeight) {
      $container2.addClass('sticky');
    } else {
      $container2.removeClass('sticky');
    }
  }
}).trigger('scroll');

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.js-open-rebuy-cart');
  if (!btn) return; 

  // Evita que iOS navegue a /cart
  e.preventDefault();
  e.stopPropagation();

  
  // Muestra el sidebar de Rebuy
  if (window.Rebuy && window.Rebuy.SmartCart) {
    console.log('entro por aca', window.Rebuy)
    window.Rebuy.SmartCart.show();
  } else {
    // Fallback si Rebuy no está cargado
    window.location.href = '/cart';
  }
});

// Bundle guard: if a user modifies (adds/removes) any automatically-added
// bundle component, clear the entire cart to prevent discount abuse.
(function () {
  var _bundleGuardProcessing = false;

  function parseBundleRecipe(recipeStr) {
    var map = new Map();
    if (!recipeStr) return map;
    recipeStr.split(',').forEach(function (entry) {
      var parts = entry.split(':');
      if (parts.length === 2) {
        var id = Number(parts[0]);
        var qty = Number(parts[1]);
        if (id && qty) map.set(id, qty);
      }
    });
    return map;
  }

  function checkBundleIntegrity() {
    if (_bundleGuardProcessing) return;
    _bundleGuardProcessing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];

        // Find all parent bundle items that have a recipe
        var parents = items.filter(function (item) {
          return (
            item.properties &&
            item.properties._bundle_role === 'parent' &&
            item.properties._bundle_recipe_abs
          );
        });

        if (parents.length === 0) {
          _bundleGuardProcessing = false;
          return;
        }

        var tampered = false;

        parents.forEach(function (parent) {
          var bundleGroup = parent.properties._bundle_group;
          var recipe = parseBundleRecipe(parent.properties._bundle_recipe_abs);

          // Find component items belonging to this bundle group
          var components = items.filter(function (item) {
            return (
              item.properties &&
              item.properties._bundle_role === 'component' &&
              item.properties._bundle_group === bundleGroup
            );
          });

          // Sum actual quantities per variant ID (within this bundle group)
          var actualQtys = new Map();
          components.forEach(function (item) {
            var prev = actualQtys.get(item.variant_id) || 0;
            actualQtys.set(item.variant_id, prev + item.quantity);
          });

          // Compare against the recipe
          recipe.forEach(function (expectedQty, variantId) {
            var actualQty = actualQtys.get(variantId) || 0;
            if (actualQty !== expectedQty) {
              tampered = true;
            }
          });
        });

        if (!tampered) {
          _bundleGuardProcessing = false;
          return;
        }

        // Bundle was modified — clear the cart
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function (r) { return r.json(); })
          .then(function () {
            _bundleGuardProcessing = false;

            // Close and refresh the Rebuy SmartCart
            if (window.Rebuy && window.Rebuy.SmartCart) {
              window.Rebuy.SmartCart.close();
            }

            // Update the theme's header cart count/HTML
            if (typeof BT !== 'undefined' && BT.updateHeaderCartHtml) {
              BT.updateHeaderCartHtml(false);
            }

            // Show a user-facing message using the theme's notify system
            var msg = 'Bundle items cannot be modified individually. Your cart has been cleared — please add the bundle again.';
            if (typeof BT !== 'undefined' && BT.showNotify) {
              BT.showNotify(msg, 'danger');
            } else {
              alert(msg);
            }
          })
          .catch(function () { _bundleGuardProcessing = false; });
      })
      .catch(function () { _bundleGuardProcessing = false; });
  }

  document.addEventListener('rebuy:cart.change', checkBundleIntegrity);
}());

